import React from 'react'
import { Grid, Paper, Typography, Divider,Link } from '@material-ui/core';
import CodeBase from './codeComponent';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';

export default class TodoAppWithReact extends React.Component {

    constructor(props) {
        super(props);
        window.addEventListener('resize', this.update)
        this.state = {
            update: false,
        }
    }
    update = () => { this.setState({ update: (!this.state.update) }); }
    normalView = () => {
        let className =  'textDescription' 
        return <Grid container justify='center'>
            <Grid item md={10} lg={10}>
                <Paper style={{ padding: '20px', margin: '20px', paddingLeft: '100px', paddingRight: '100px' }}>
                    <Typography className='textTitle' variant='h4' >Todo App example using Reactjs</Typography>
                    <Divider />
                    <Typography className={className}>
                        Here in this section we will build a todo app using actumjs with Reactjs.
                    <br/>
                    First thing you need to do is creating a new reactjs app using `create-react-app` CLI.
                  </Typography>
                    <CodeBase
                        lines={["$ npx create-react-app todo_app"]}
                    />
                    <Typography className={className}>
                        Once your project is created using `create-react-app`,Now we need to install Actumjs.
                    </Typography>
                    <CodeBase
                        lines={["$ npm install  @actumjs/actum"]}
                    />
                    <Typography className={className}>
                    Inside your todo_app/src folder, Create a folder named `store`,Along with file index.js .<br />
                    Import `createStore` from the Actumjs package and create the store using it as shown below.
                </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            "// File : src/store/index.js \n",
                            "import {createStore} from '@actumjs/actum';\n",
                            "const initialState = {todos:[]};\n",
                            "const store = createStore(initialState);\n",
                            "export default store;\n"
                        ]}
                    />
                    <Typography className={className}>
                        After that we need to describe actions that update the store,For that,Let's create a folder named `actions` having file index.js inside
                        todo_app/src.
                      <br />
                        Describe the actions as show below
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `// File : src/actions/index.js\n`,
                            `export function addTodo(payload,state){\n`,
                            `    let todos = state.todos;\n`,
                            `    let id=1;\n`,
                            `    if(todos.length>0){\n`,
                            `        id = todos[todos.length-1].id+1;\n`,
                            `    }\n`,
                            `    todos.push({id:id,description:payload});\n`,
                            `}\n`,
                            `\n`,
                            `export function updateTodo(payload,state){\n`,
                            `    let todos = state.todos;\n`,
                            `    let editedTodo=todos.find(function(todo){return todo.id==payload.id});\n`,
                            `    if(editedTodo!==undefined){\n`,
                            `        editedTodo.todo=payload.todo;\n`,
                            `    }\n`,
                            `}\n`,
                            `\n`,
                            `export function deleteTodo(payload,state){\n`,
                            `    state.todos = state.todos.filter(function(todo){return todo.id!=payload.id});\n`,
                            `}\n`,

                        ]}
                    />
                    <Typography className={className}>
                        At this point both actions and store is defined,Now we attach actions to store by using addAction method of store object.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File : src/store/index.js
import {createStore} from '@actumjs/actum';
import { addTodo, updateTodo, deleteTodo } from '../actions'

let initialState = { todos: [] }

let store = createStore(initialState);

store.addAction("addTodo", addTodo);
store.addAction("updateTodo", updateTodo);
store.addAction("deleteTodo", deleteTodo);

export default store;
            `
                        ]}
                    />
                    <Typography className={className}>
                        Now we need to create a component to add todos into the  store,We will describe our `AddTodo` component as below
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File :  src/components/AddTodo.js
import React from 'react'
import store from '../store'
export default class AddTodo extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            errorMessage:'',
            description:''
        }
    }
    addTodo=()=>{
        if(this.state.description==""){
            this.setState({
                errorMessage:"Please enter description"
            })
        }else{
            //trigger the action
            store.trigger("addTodo",this.state.description);
            //clear the state
            this.setState({errorMessage:'',description:''});
        }
        
    }
    handleInput=(name,value)=>{
        let curState=this.state;
        curState[name]=value;
        this.setState(curState);
    }
    render() {
        return <>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <span className="text-danger text-left">{ this.state.errorMessage }</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 input-group">
                        <input className="form-control" placeholder="Enter Todo here" value={this.state.description} onChange={(e)=>{this.handleInput("description",e.target.value)}}/>
                        <button className="btn btn-primary" onClick={this.addTodo}>Add</button>
                    </div>
                </div>
            </div>
        </>

    }
}
`
                        ]}
                    />
                    <Typography className={className}>
                        After having component to add todos ,Let's have List and ListItem component to show todo items.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File : src/components/ListItem.js
import React from 'react'
import store from '../store';
export default class ListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            curTodo: props.todo
        }
    }

    deleteTodo = () => {
        store.trigger("deleteTodo", this.state.curTodo);
    }
    doEdit = () => {
        this.setState({ isEditing: true })
    }
    cancelEditing = () => {
        this.setState({ isEditing: false })
    }
    save = () => {
        store.trigger("updateTodo", this.state.curTodo);
        this.setState({ isEditing: false })
    }
    handleInput = (value) => {
        let curTodo = this.state.curTodo;
        curTodo.description = value;
        this.setState({
            curTodo: curTodo
        })
    }

    render() {
        if (this.state.isEditing) {
            return <>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-2">{this.state.curTodo.id}</div>
                    <div className="col-md-2">
                        <input type="text" className="form-control" value={this.state.curTodo.description} onChange={(e) => { this.handleInput(e.target.value) }} />
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-primary" onClick={this.save}>Save</button>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-danger" onClick={this.cancelEditing}>Cancel</button>
                    </div>
                </div>
            </>
        } else {
            return <>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-2">{this.props.todo.id}</div>
                    <div className="col-md-2">{this.props.todo.description}</div>
                    <div className="col-md-1">
                        <button className="btn btn-info" onClick={this.doEdit}>Edit</button>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-secondary" onClick={this.deleteTodo}>Delete</button>
                    </div>
                </div>
            </>
        }

    }
}
             `
                        ]}
                    />
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File src/components/List.js
import React from 'react'
import store from '../store';
import ListItem from './ListItem';
export default class List extends React.Component {
    constructor(props) {
        super(props);
    }
    getContent = () => {
        let todos = store.getState().todos;
        if (todos.length <= 0) {
            return <div className="row" style={{marginTop:"10px"}}><div className="col-md-6" ><h5>No todos to show</h5></div></div>
        }
        return <>{todos.map(todo=><ListItem key={todo.id} todo={todo} />)}</>
    }
    render() {
        let content = this.getContent();
        return <div className="container">
                    {content}
            </div>
    }
}
`
                        ]}
                    />
                    <Typography className={className}>
                        Till now we have list component that render todo items from store ,Each time when the store is updated we need to update/re-render our component,
                        Inorder to do this we will attach listeners to store actions.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File src/components/List.js

import React from 'react'
import store from '../store';
import ListItem from './ListItem';
export default class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = { update: false }
    }
    componentDidMount(){
        //add listeners to actions
        this.afterAddTodo = store.after("addTodo", this.update);
        this.afterdeleteTodo = store.after("deleteTodo", this.update);
        this.aftereditTodo = store.after("updateTodo", this.update);
    }
    componentWillUnmount(){
        //remove listeners 
        this.afterAddTodo();
        this.afterdeleteTodo();
        this.aftereditTodo();
    }
    update = () => {
        this.setState({ update: !this.state.update })
    }
    getContent = () => {
        let todos = store.getState().todos;
        if (todos.length <= 0) {
            return <div className="row" style={{marginTop:"10px"}}><div className="col-md-6" ><h5>No todos to show</h5></div></div>
        }
        return <>{todos.map(todo=><ListItem key={todo.id} todo={todo} />)}</>
    }
    render() {
        let content = this.getContent();
        return <div className="container">
                    {content}
            </div>
    }
}
           `
                        ]}
                    />

                    <Typography className={className + " devtip"}>
                            Its important to remove action listeners once component is no longer mounted,So what will happen if we don't remove action's listeners?
                            In this case action listeners will be called to update state of component which is not mounted.
                    </Typography>
                    <Typography className={className}>
                            Finally we will place all component inside our app component.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
`
//File : src/App.js
import React from 'react'
import AddTodo from './components/AddTodo';
import List from './components/List';
export default class App extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return <>
            <div className="container">
                <div className="row">
                    <h1>Todos</h1>
                </div>
                <AddTodo />
                <List />
            </div>

        </>

    }
}
`

                        ]}/>
<Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                    <Grid item >
                        <Link href="/examples">
                            <ArrowLeft/>back to examples
                        </Link>
                    </Grid>
                </Grid>

                </Paper>
            </Grid>
        </Grid>
    }
    mobileView = () => {
        let className = 'textDescriptionMobile';
        return <div style={{ padding: '10px'}}>
                    <Typography className='textTitle' variant='h4' >Todo App example using Reactjs</Typography>
                    <Divider />
                    <Typography className={className}>
                        Here in this section we will build a todo app using actumjs with Reactjs.
                    <br />
                    First thing you need to do is creating a new reactjs app using `create-react-app` CLI,If you don't have it on your system you can install it using npm.
                </Typography>
                    <CodeBase
                        lines={["$ npx create-react-app todo_app"]}
                    />
                    <Typography className={className}>
                        Once your project is created using `create-react-app`,Now we need to install Actumjs.
                </Typography>
                    <CodeBase
                        lines={["$ npm install  @actumjs/actum"]}
                    />
                    <Typography className={className}>
                        Inside your todo_app/src folder, Create a folder named `store`,Along with file index.js .<br />
                    Import `createStore` from the Actumjs package and create the store using it as shown below.
                </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            "// File : src/store/index.js \n",
                            "import {createStore} from '@actumjs/actum';\n",
                            "const initialState = {todos:[]};\n",
                            "const store = createStore(initialState);\n",
                            "export default store;\n"
                        ]}
                    />
                    <Typography className={className}>
                        After that we need to describe actions that update the store,For that,Let's create a folder named `actions` having file index.js inside
                        todo_app/src.
          <br />
          Describe the actions as show below
     </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `// File : src/actions/index.js\n`,
                            `export function addTodo(payload,state){\n`,
                            `    let todos = state.todos;\n`,
                            `    let id=1;\n`,
                            `    if(todos.length>0){\n`,
                            `        id = todos[todos.length-1].id+1;\n`,
                            `    }\n`,
                            `    todos.push({id:id,description:payload});\n`,
                            `}\n`,
                            `\n`,
                            `export function updateTodo(payload,state){\n`,
                            `    let todos = state.todos;\n`,
                            `    let editedTodo=todos.find(function(todo){return todo.id==payload.id});\n`,
                            `    if(editedTodo!==undefined){\n`,
                            `        editedTodo.todo=payload.todo;\n`,
                            `    }\n`,
                            `}\n`,
                            `\n`,
                            `export function deleteTodo(payload,state){\n`,
                            `    state.todos = state.todos.filter(function(todo){return todo.id!=payload.id});\n`,
                            `}\n`,

                        ]}
                    />
                    <Typography className={className}>
                        At this point both actions and store is defined,Now we attach actions to store by using addAction method of store object.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File : src/store/index.js
import {createStore} from '@actumjs/actum';
import { addTodo, updateTodo, deleteTodo } from '../actions'

let initialState = { todos: [] }

let store = createStore(initialState);

store.addAction("addTodo", addTodo);
store.addAction("updateTodo", updateTodo);
store.addAction("deleteTodo", deleteTodo);

export default store;
            `
                        ]}
                    />
                    <Typography className={className}>
                        Now we need to create a component to add todos into the  store,We will describe our `AddTodo` component as below
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File :  src/components/AddTodo.js
import React from 'react'
import store from '../store'
export default class AddTodo extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            errorMessage:'',
            description:''
        }
    }
    addTodo=()=>{
        if(this.state.description==""){
            this.setState({
                errorMessage:"Please enter description"
            })
        }else{
            //trigger the action
            store.trigger("addTodo",this.state.description);
            //clear the state
            this.setState({errorMessage:'',description:''});
        }
        
    }
    handleInput=(name,value)=>{
        let curState=this.state;
        curState[name]=value;
        this.setState(curState);
    }
    render() {
        return <>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <span className="text-danger text-left">{ this.state.errorMessage }</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 input-group">
                        <input className="form-control" placeholder="Enter Todo here" value={this.state.description} onChange={(e)=>{this.handleInput("description",e.target.value)}}/>
                        <button className="btn btn-primary" onClick={this.addTodo}>Add</button>
                    </div>
                </div>
            </div>
        </>

    }
}
`
                        ]}
                    />
                    <Typography className={className}>
                        After having component to add todos ,Let's have List and ListItem component to show todo items.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File : src/components/ListItem.js
import React from 'react'
import store from '../store';
export default class ListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            curTodo: props.todo
        }
    }

    deleteTodo = () => {
        store.trigger("deleteTodo", this.state.curTodo);
    }
    doEdit = () => {
        this.setState({ isEditing: true })
    }
    cancelEditing = () => {
        this.setState({ isEditing: false })
    }
    save = () => {
        store.trigger("updateTodo", this.state.curTodo);
        this.setState({ isEditing: false })
    }
    handleInput = (value) => {
        let curTodo = this.state.curTodo;
        curTodo.description = value;
        this.setState({
            curTodo: curTodo
        })
    }

    render() {
        if (this.state.isEditing) {
            return <>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-2">{this.state.curTodo.id}</div>
                    <div className="col-md-2">
                        <input type="text" className="form-control" value={this.state.curTodo.description} onChange={(e) => { this.handleInput(e.target.value) }} />
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-primary" onClick={this.save}>Save</button>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-danger" onClick={this.cancelEditing}>Cancel</button>
                    </div>
                </div>
            </>
        } else {
            return <>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-2">{this.props.todo.id}</div>
                    <div className="col-md-2">{this.props.todo.description}</div>
                    <div className="col-md-1">
                        <button className="btn btn-info" onClick={this.doEdit}>Edit</button>
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-secondary" onClick={this.deleteTodo}>Delete</button>
                    </div>
                </div>
            </>
        }

    }
}
             `
                        ]}
                    />
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File src/components/List.js
import React from 'react'
import store from '../store';
import ListItem from './ListItem';
export default class List extends React.Component {
    constructor(props) {
        super(props);
    }
    getContent = () => {
        let todos = store.getState().todos;
        if (todos.length <= 0) {
            return <div className="row" style={{marginTop:"10px"}}><div className="col-md-6" ><h5>No todos to show</h5></div></div>
        }
        return <>{todos.map(todo=><ListItem key={todo.id} todo={todo} />)}</>
    }
    render() {
        let content = this.getContent();
        return <div className="container">
                    {content}
            </div>
    }
}
`
                        ]}
                    />
                    <Typography className={className}>
                        Till now we have list component that render todo items from store ,Each time when the store is updated we need to update/re-render our component,
                        Inorder to do this we will attach listeners to store actions.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
                            `
//File src/components/List.js

import React from 'react'
import store from '../store';
import ListItem from './ListItem';
export default class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = { update: false }
    }
    componentDidMount(){
        //add listeners to actions
        this.afterAddTodo = store.after("addTodo", this.update);
        this.afterdeleteTodo = store.after("deleteTodo", this.update);
        this.aftereditTodo = store.after("updateTodo", this.update);
    }
    componentWillUnmount(){
        //remove listeners 
        this.afterAddTodo();
        this.afterdeleteTodo();
        this.aftereditTodo();
    }
    update = () => {
        this.setState({ update: !this.state.update })
    }
    getContent = () => {
        let todos = store.getState().todos;
        if (todos.length <= 0) {
            return <div className="row" style={{marginTop:"10px"}}><div className="col-md-6" ><h5>No todos to show</h5></div></div>
        }
        return <>{todos.map(todo=><ListItem key={todo.id} todo={todo} />)}</>
    }
    render() {
        let content = this.getContent();
        return <div className="container">
                    {content}
            </div>
    }
}
           `
                        ]}
                    />

                    <Typography className={className + " devtip"}>
                            Its important to remove action listeners once component is no longer mounted,So what will happen if we don't remove action's listeners?
                            In this case action listeners will be called to update state of component which is not mounted.
                    </Typography>
                    <Typography className={className}>
                            Finally we will place all component inside our app component.
                    </Typography>
                    <CodeBase
                        lang='js'
                        lines={[
`
//File : src/App.js
import React from 'react'
import AddTodo from './components/AddTodo';
import List from './components/List';
export default class App extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return <>
            <div className="container">
                <div className="row">
                    <h1>Todos</h1>
                </div>
                <AddTodo />
                <List />
            </div>

        </>

    }
}
`

                        ]}/>
                        <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                    <Grid item >
                        <Link href="/examples">
                            <ArrowLeft/>back to examples
                        </Link>
                    </Grid>
                </Grid>
                </div>
    }
    render() {
        let content = null;
        if (window.screen.width <= 768) {
            content = this.mobileView();
        } else {
            content = this.normalView();
        }
        return <div style={{ marginTop: '70px', color: 'white', marginBottom: "20px" }}>
            {content}
        </div>;
    }
}